import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { getAllReleaseNotes } from '../actions/get-release-notes'

export interface ReleaseNote {
  lastModified: string
  name: string
  versionId: string
}
export interface ReleaseNoteData {
  latestVersion: string
  list: ReleaseNote[]
}

export interface ReleaseNotesState {
  data: ReleaseNoteData | null
  error: string | null
  loading: boolean
}

const initialState: ReleaseNotesState = {
  data: null,
  error: null,
  loading: false,
}

export const getReleaseNotesAction = createAsyncThunk(
  '/webhook/all-release-pdf-notes',
  async () => {
    return await getAllReleaseNotes()
  }
)

export const ReleaseNotesSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(getReleaseNotesAction.pending, (state) => {
        state.error = null
        state.loading = true
      })
      .addCase(getReleaseNotesAction.fulfilled, (state, action) => {
        state.data = action.payload.data as ReleaseNoteData
        state.error = null
        state.loading = false
      })
      .addCase(getReleaseNotesAction.rejected, (state, action) => {
        state.error = action.error.message ?? 'Error fetching release notes'
        state.loading = false
      })
  },
  initialState,
  name: 'ReleaseNotesSlice',
  reducers: {
    resetReleaseNotesData: (state) => {
      state.data = null
      state.error = null
      state.loading = false
    },
  },
})

export const { resetReleaseNotesData } = ReleaseNotesSlice.actions
